// @ts-ignore
import validator from 'validator';

const MESSAGE_ERROR = 'Обязательное поле';
const MESSAGE_INVALID_EMAIL = 'Неправильный email';
const MESSAGE_INVALID_PHONE = 'Неправильный номер телефона';
const MESSAGE_INVALID_YEAR = 'Неправильное значение года';
const MESSAGE_INVALID_LENGTH = 'Неверная длина';
const MESSAGE_INVALID_INN = 'Неверное значение ИНН';
const MESSAGE_INVALID_KPP = 'Неверное значение КПП';

export const required = (value: any) => {
  let error;
  if (!value) error = MESSAGE_ERROR;
  if (typeof value === 'string' && validator.isEmpty(value)) error = MESSAGE_ERROR;
  return error;
};

export const requiredArray = (value: any[]) => {
  let error;
  if (!value || !value.length) error = MESSAGE_ERROR;
  return error;
};

export const isEmail = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = MESSAGE_INVALID_EMAIL;
  }
  return error;
}

export const isEmailOptional = (value: string) => {
  let error;
  if (!value) return error;

  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = MESSAGE_INVALID_EMAIL;
  }
  return error;
}

export const isPhone = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
    return error;
  }
  error = validatePhone(value);
  return error;
}

export const isPhoneOptional = (value: string) => {
  let error;
  if (!value) return error;
  error = validatePhone(value);
  return error;
}

const validatePhone = (value: string) => {
  let error;
  const isValid = /^\+[0-9]{10,}$/.test(value);
  if (!isValid) {
    error = MESSAGE_INVALID_PHONE;
  }
  return error;
}

export const isYear = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!/^\d{4}$/.test(value)) {
    error = MESSAGE_INVALID_YEAR;
  }
  return error;
}


export const checkLength = (length: number) => (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (value.length < length) {
    error = MESSAGE_INVALID_LENGTH;
  }
  return error;
}

export const isValidTime = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!/^([01]\d|2[0123]):(?:[012345]\d)$/.test(value)) {
    error = MESSAGE_INVALID_LENGTH;
  }
  return error;
}

export const isKpp= (value: string) => {
  let error;
  const regExpKpp = /^\d{9}$/;

  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!regExpKpp.exec(value)) {
    error = MESSAGE_INVALID_KPP;
  }
  return error;
}

export const isInn = (value:any) => {
  let error;
    //преобразуем в строку
    value = '' + value;
    //преобразуем в массив
    value = value.split('');
    //для ИНН в 10 знаков
    if (!value) {
      error = MESSAGE_ERROR;
    }
    else if (
      !((value.length === 10 &&
      value[9] ===
        ((2 * value[0] +
          4 * value[1] +
          10 * value[2] +
          3 * value[3] +
          5 * value[4] +
          9 * value[5] +
          4 * value[6] +
          6 * value[7] +
          8 * value[8]) %
          11) %
          10)
 ||      (value.length === 12 &&
      (value[10] ===
        ((7 * value[0] +
          2 * value[1] +
          4 * value[2] +
          10 * value[3] +
          3 * value[4] +
          5 * value[5] +
          9 * value[6] +
          4 * value[7] +
          6 * value[8] +
          8 * value[9]) %
          11) %
          10 &&
        value[11] ===
          ((3 * value[0] +
            7 * value[1] +
            2 * value[2] +
            4 * value[3] +
            10 * value[4] +
            3 * value[5] +
            5 * value[6] +
            9 * value[7] +
            4 * value[8] +
            6 * value[9] +
            8 * value[10]) %
            11) %
            10)
    ))) {
      error = MESSAGE_INVALID_INN;
    }
  return error;

}
